import React from "react"

import { Download } from "lucide-react"

interface DocumentLinkProps {
  ext?: string
  text: string
  slug: string
  size?: string
  rewrite?: boolean
}

const DocumentLink = ({
  ext = "pdf",
  text,
  slug,
  size,
  rewrite = false,
}: DocumentLinkProps) => (
  <a
    className="group flex items-center gap-x-2 p-4 capitalize *:text-black odd:bg-slate-100/60"
    href={slug}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Download className="size-14 shrink-0 stroke-black" />
    <div className="flex shrink flex-col">
      <p className="line-clamp-2 text-lg font-semibold group-hover:text-slate-500">
        {rewrite === true ? text.replaceAll("_", " ") : text}
      </p>
      {size && (
        <span className="text-sm font-thin !lowercase">
          (.{ext} {size})
        </span>
      )}
    </div>
  </a>
)

export default DocumentLink
